export default "/images/c2336646a62b0cb79aad5db1ced46953.avif";